webpackJsonp([257817010790598],{

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Models = __webpack_require__(18);
	
	var _Models2 = _interopRequireDefault(_Models);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Models2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'has'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'has()'
	      ),
	      ' method can be used to get a true/false value based on whether an attribute exists on the model.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Values that are ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'undefined'
	      ),
	      ' or ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'null'
	      ),
	      ' will return ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'false'
	      ),
	      '. Any other value will return ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'true'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Default Implementation'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default implementation looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      has: function(attr) {\n        return this.get(attr) != null;\n      },\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Let\'s use this code to illustrate:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import { Model } from \'lore-models\';\n\n      const Tweet = Model.extend();\n\n      const tweet = new Tweet({\n        id: 1,\n        text: \'Some old tweet\'\n      });\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the code above, ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet.has(\'text\')'
	      ),
	      ' will return ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'true'
	      ),
	      ', whereas ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet.has(\'user\')'
	      ),
	      ' would return ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'false'
	      ),
	      ' because it\'s not defined.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-models-properties-has-js-92d02d5265dcf95b1841.js